import React from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { ExclamationCircleIcon } from '@heroicons/react/16/solid'

export default function TwInputGroup(props) {
  const loadingReduxState = useSelector(loadingState);
  const { children, name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "", wrapperClassName = "w-full sm:w-full sm:max-w-sm md:max-w-lg" } = props
  let inputProps = { ...props }
  delete inputProps.wrapperClassName
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.inputClass
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.inputClass && props.inputClass !== "") {
    inputClass = inputClass + " " + props.inputClass
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }
  if (inputProps.disabled && inputProps.disabled !== undefined) {
    inputClass += " !bg-gray-200"
  }


  return (
    // <div className="sm:w-full sm:max-w-sm md:max-w-lg">
    <div className={wrapperClassName}>
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className={label ? "mt-2" : ""}>
        <div className={classNames("flex items-center rounded-xl bg-input-bz px-4 md:px-5 outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2", inputClass)}>
          {leftIcon && (
            <div className="shrink-0 select-none text-base text-gray-500 sm:text-sm/6">{leftIcon}</div>
          )}
          <input
            {...inputProps}
            aria-invalid={props.error ? "true" : ""}
            aria-describedby={props.error ? "email-error" : ""}
            className={classNames("bg-transparent block min-w-0 grow py-5 pl-3 md:py-5 md:pl-5 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6 disabled:bg-gray-200",
              props.error ? "pr-3" : "pr-0",
              className
            )}
          />
          {rightIcon && (
            <div className="[size-5] bg-transparent">{rightIcon}</div>
          )}
          {props.error && (<ExclamationCircleIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
          />)}
        </div>
      </div>
      {props?.helperText && (<p className="mt-2 text-sm text-gray-400">
        {props.helperText}
      </p>)}
      {props.error && (<p className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
